export const refNamesObjetosVisuaisNavBase = [
	"refMenuAssinaturas365",
	"refMenuUsuarios",
	"refMenuUsuariosExcluidos",
	"refMenuAtendimentos",
	"refMenuSolicitacaoServicos",
	"refMenuFinanceiro",
	"refMenuGrupos",
	"refMenuPrecisoSuporte",
	"refRelatorioAzure",
	"refRelatorioFaturamentoMaster",
	"refRelatorioLicenciamentoCsp",
	"refRelatorioExtratoUsuario",
	"refRelatorioAtendimentos",
	"refRelatorioSuportePremium",
	"refRelatorioPainelFinOps",
	"refMenuAtualizarMeusDadosLateral",
	"refMenuAlterarSenhaLateral",
	"refSairLateral",
];

export const refNamesObjetosVisuaisUsuariosExcluidos = [
    'refBotaoRestaurar', 
    'refFiltroUsuarios', 
    'refPaginacaoUsuarios'
];